import React from 'react';
import PropTypes from 'prop-types';

import store from '@Store';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfHopintoInvalidParamsDialog } from '@Pages/Hopinto/constants';
import DialogWithErrorLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithErrorLayout';

export default function HopintoInvalidParamsDialog(props) {
  const { message } = props;
  return (
    <DialogWithErrorLayout
      {...props}
      className="hopinto-invalid-parameters-dialog"
      size="md"
      selfClose={() => {
        store.dispatch(closeDialog({ id: typeOfHopintoInvalidParamsDialog }));
      }}>
      {message}
    </DialogWithErrorLayout>
  );
}

HopintoInvalidParamsDialog.propTypes = {
  message: PropTypes.string,
};
